
import React from "react";
import { Button } from "@/components/ui/button";

interface InvestorsSortControlsProps {
  sortField: "relevanceScore" | "firm";
  sortDirection: "asc" | "desc";
  onSortChange: (field: "relevanceScore" | "firm") => void;
}

const InvestorsSortControls = ({ 
  sortField, 
  sortDirection, 
  onSortChange 
}: InvestorsSortControlsProps) => {
  return (
    <div className="flex gap-2 mb-2">
      <Button
        size="sm"
        variant={sortField === "relevanceScore" ? "default" : "outline"}
        onClick={() => onSortChange("relevanceScore")}
        className="text-xs"
      >
        Sort by Relevance{" "}
        {sortField === "relevanceScore" && (sortDirection === "asc" ? "↑" : "↓")}
      </Button>
      <Button
        size="sm"
        variant={sortField === "firm" ? "default" : "outline"}
        onClick={() => onSortChange("firm")}
        className="text-xs"
      >
        Sort by Firm {sortField === "firm" && (sortDirection === "asc" ? "↑" : "↓")}
      </Button>
    </div>
  );
};

export default InvestorsSortControls;
